// src/pages/LoginPage.js
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'

function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const navigate = useNavigate()

  const handleLogin = async (e) => {
  e.preventDefault()
  setError(null)

  const { data: signInData, error: signInError } = await supabase.auth.signInWithPassword({
    email,
    password,
  })

  if (signInError) {
    setError(signInError.message)
    return
  }

  const userId = signInData.user.id
  const userEmail = signInData.user.email

  // Check if user already exists in `users` table
  const { data: existingUser, error: fetchError } = await supabase
    .from('users')
    .select('id')
    .eq('id', userId)
    .single()

  if (fetchError && fetchError.code !== 'PGRST116') {
    console.error(fetchError)
    setError('Login failed: unable to fetch user record')
    return
  }

  if (!existingUser) {
    const { error: insertError } = await supabase.from('users').insert([
      {
        id: userId,
        full_name: userEmail.split('@')[0],
        role: userEmail === 'demo@cuvriq.com' ? 'demo' : 'viewer',
      },
    ])

    if (insertError) {
      console.error(insertError)
      setError('Login failed: unable to create user profile')
      return
    }
  }

  // Redirect based on email
  if (userEmail === 'demo@cuvriq.com') {
    navigate('/chat')
  } else {
    navigate('/dashboard')
  }
}


  return (
  <div
    style={{
      minHeight: '100vh',
      backgroundColor: '#f1f5f9',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      fontFamily: 'Arial, sans-serif',
    }}
  >
    <div
      style={{
        backgroundColor: '#ffffff',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        padding: '2rem',
        width: '100%',
        maxWidth: '400px',
      }}
    >
      <img
  src="/cuvriq-logo.png"
  alt="CuvrIQ Logo"
  style={{
    width: "100%",
    maxWidth: '400px',
    display: 'block',
    margin: '0 auto 0rem',
    padding: '0.25rem',
    objectFit: 'contain',
    filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.1))',
  }}
/>



      <form onSubmit={handleLogin}>
        <label style={{ display: 'block', marginBottom: '0.5rem', color: '#334155' }}>
          Email
        </label>
        <input
          type="email"
          placeholder="you@example.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          style={{
            width: '92%',
            padding: '0.75rem',
            marginBottom: '1rem',
            border: '1px solid #cbd5e1',
            borderRadius: '6px',
            fontSize: '1rem',
          }}
        />

        <label style={{ display: 'block', marginBottom: '0.5rem', color: '#334155' }}>
          Password
        </label>
        <input
          type="password"
          placeholder="••••••••"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          style={{
            width: '92%',
            padding: '0.75rem',
            marginBottom: '1rem',
            border: '1px solid #cbd5e1',
            borderRadius: '6px',
            fontSize: '1rem',
          }}
        />

        {error && (
          <p style={{ color: '#ef4444', marginBottom: '1rem', fontSize: '0.9rem' }}>{error}</p>
        )}

        <button
          type="submit"
          style={{
            width: '100%',
            backgroundColor: '#2563eb',
            color: '#ffffff',
            padding: '0.75rem',
            borderRadius: '6px',
            fontWeight: 'bold',
            fontSize: '1rem',
            border: 'none',
            cursor: 'pointer',
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = '#1d4ed8')}
          onMouseLeave={(e) => (e.target.style.backgroundColor = '#2563eb')}
        >
          Log In
        </button>
      </form>

      <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.95rem', color: '#475569' }}>
        Don’t have an account?{' '}
        <a href="/signup" style={{ color: '#2563eb', textDecoration: 'underline' }}>
          Sign up
        </a>
      </p>
    </div>
  </div>
)


}

export default LoginPage
